<template>
  <div class="row">
    <div class="col-12 col-lg">
      <div
        class="mb-1 font-weight-bold"
        :class="{ 'text-transparent text-center small': !title }"
      >
        {{ title | empty }}
      </div>
      <div class="rounded py-2 bg-gray-9" />
      <div class="mt-3 d-flex align-items-center">
        <div>
          <p class="font-weight-bold mb-1 py-1" v-html="name" />
          <span v-html="notes" />
        </div>
      </div>
    </div>
    <div
      v-for="(answer, key) in data.answers"
      :key="answer.answerId"
      class="col-md-custom col-6 px-0"
    >
      <div class="text-center small mb-1 font-weight-bold">
        {{ answer.text | empty }}
      </div>
      <div
        class="rounded py-2 mx-2"
        :style="{ backgroundColor: answer.color }"
      />
      <div
        class=" my-3 py-3 border-top border-bottom"
        :class="{
          'ml-2 border-left rounded-left': key === 0,
          'mr-2 border-right rounded-right': key === data.answers.length - 1,
          'bg-gray-9': isReadOnly || answer.answerId === checked,
          'cursor-no-drop': isReadOnly,
          'cursor-pointer': !isReadOnly,
        }"
        @click="onSelectAnswer(answer.answerId)"
      >
        <div class="text-center">
          <b-form-radio
            :checked="checked"
            class="pl-4 ml-3 custom-radio"
            :disabled="isReadOnly"
            size="lg"
            :value="answer.answerId"
            @input="onSelectAnswer"
          />
          {{ answer.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RubricPreviewQuestionExpectative',
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => null,
    },
  },
  computed: {
    name() {
      return this.data.name.split('<br/>')[0];
    },
    notes() {
      return this.data.name.split('<br/>')[1];
    },
    checked() {
      return this.value?.answerId;
    },
  },
  methods: {
    onSelectAnswer(answerId) {
      if (this.isReadOnly) {
        return false;
      }
      const answer = this.data.answers.find((x) => x.answerId === answerId);
      this.$emit('input', answer);
    },
  },
};
</script>

<style scoped lang="scss">
.text-transparent {
  color: transparent;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-no-drop {
  cursor: not-allowed;
}
@media (min-width: 768px) {
  .col-md-custom {
    max-width: 12%;
  }
  .h-md-60 {
    height: 60%;
  }
}

.custom-radio
  ::v-deep
  .custom-control-input:disabled:checked
  ~ .custom-control-label::before {
  background-color: rgba(45, 183, 130, 0.5);
}
</style>
